import i18n from "@/i18n"
import Cookies from 'js-cookie'
import uien from 'element-ui/lib/locale/lang/en'
import uicn from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

// 设置语言

export default {
    namespaced: true,
    state: {
        localeLanguage: Cookies.get('t-language') || 'zh-CN',
        showLanguageSelector: false
    },
    actions: {

    },
    mutations: {
        UPDATE_LOCALE_LANGUAGE(state, payload) {
            Cookies.set('t-language', payload)
            state.localeLanguage = payload
            let uiL = payload === "zh-CN" ? uicn : uien
            locale.use(uiL)
            i18n.locale = payload
        },
        languageSelector(state, payload) {
            state.showLanguageSelector = payload
        }
    },
    getters: {
        localeLanguage(state) {
            return state.localeLanguage
        },
        showLSelector(state) {
            return state.showLanguageSelector
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js